import request from "@/utils/request";
import qs from "qs";

/**
 * 创建广告
 * @param params
 * @returns {*}
 */
export function createAd(params) {
  return request.post("/api/backend/setting/appletad/createAd", qs.stringify(params));
}

/**
 * 查询广告
 * @param params
 * @returns {*}
 */
export function getAdList(params) {
  return request({
    url: "/api/backend/setting/appletad/getList",
    method: "get",
    params
  });
}

/**
 * 修改状态
 * @param params
 * @returns {AxiosPromise}
 */
export function updateStatusAd(params) {
  return request.post("/api/backend/setting/appletad/updateStatus", qs.stringify(params));
}

// ==================================账户配置 start=================

/**
 * 查询账户配置
 * @param params
 * @return {AxiosPromise}
 */
export function getCategoryConfig(params) {
  return request({
    url: "/acctconfig/getCategoryConfig",
    method: "get",
    params
  });
}
function getSizeInMegaBytes(value) {
  let lengthInBytes = new Blob([value]).size; // 获取字节大小
  return lengthInBytes / (1024 * 1024); // 转换为MB
}
/**
 * 编辑账户配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editCategoryConfig(data) {
  return request({
    url: "/acctconfig/editCategoryConfig",
    method: "post",
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

/**
 * 查询账户类别
 * @param params
 * @return {AxiosPromise}
 */
export function getCategoryNames(params) {
  return request({
    url: "/acctconfig/getCategoryNames",
    method: "get",
    params
  });
}

/**
 * 查询账户互转类别
 * @param params
 * @return {AxiosPromise}
 */
export function getAcctTransferCategory(params) {
  return request({
    url: "/acctconfig/getAcctTransferCategory",
    method: "get",
    params
  });
}

// ==================================账户配置 end=================

// ==================================等级配置 start=================
/**
 * 查询等级配置
 * @param params
 * @return {AxiosPromise}
 */
export function getGradeList(params) {
  return request({
    url: "/gradeconfig/getList",
    method: "get",
    params
  });
}

/**
 * 查询等级配置详情
 * @param params
 * @return {AxiosPromise}
 */
export function getGradeDetail(params) {
  return request({
    url: "/gradeconfig/getDetail",
    method: "get",
    params
  });
}

/**
 * 新增-编辑等级配置
 * @param params
 * @returns {AxiosPromise}
 */
export function updateGrade(params) {
  return request.post("/gradeconfig/edit", qs.stringify(params));
}
// ==================================等级配置 end=================


// ================================== 推广奖励配置 start=================
/**
 * 查询推广奖励配置
 * @param params
 * @return {AxiosPromise}
 */
export function getRewardDetail(params) {
  return request({
    url: "/rewardconfig/getDetail",
    method: "get",
    params
  });
}
/**
 * 编辑级差奖励配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editIntervalGrade(params) {
  return request.post("/rewardconfig/editIntervalGrade", qs.stringify(params));
}
/**
 * 编辑平级奖励配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editSameGrade(params) {
  return request.post("/rewardconfig/editSameGrade", qs.stringify(params));
}
/**
 * 编辑间推奖励配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editJiantui(params) {
  return request.post("/rewardconfig/editJiantui", qs.stringify(params));
}

/**
 * 编辑直推奖励配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editZhitui(params) {
  return request.post("/rewardconfig/editZhitui", qs.stringify(params));
}

// ================================== 推广奖励配置 end=================

// ================================== 提现银行管理 start=================
/**
 * 查询银行列表
 * @param params
 * @return {AxiosPromise}
 */
export function getBankList(params) {
  return request({
    url: "/bank/getList",
    method: "get",
    params
  });
}
/**
 * 新增-编辑银行
 * @param params
 * @returns {AxiosPromise}
 */
export function editBank(params) {
  return request.post("/bank/edit", qs.stringify(params));
}

/**
 * 停用-启用银行
 * @param params
 * @returns {AxiosPromise}
 */
export function switchBankStatus(params) {
  return request.post("/bank/switchStatus", qs.stringify(params));
}

// ================================== 提现银行管理 end=================


// ================================== 查询区域代理配置 start=================
/**
 * 查询区域代理配置
 * @param params
 * @return {AxiosPromise}
 */
export function getRegionalAgentDetail(params) {
  return request({
    url: "/regionalconfig/getDetail",
    method: "get",
    params
  });
}

// 货品开关
export function getRegionalAgentSwitch(params) {
  return request.post("/regionalconfig/updateRegionalConfigState", qs.stringify(params));
}
/**
 * 编辑区域代理配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editRegionalAgent(params) {
  return request.post("/regionalconfig/editRegionalAgent", qs.stringify(params));
}
// ================================== 查询区域代理配置 end=================


// ================================== APP版本管理 start=================

/**
 * 新增-编辑版本
 * @param params
 * @returns {AxiosPromise}
 */
export function appversionEdit(params) {
  return request.post("/appversion/edit", qs.stringify(params));
}
/**
 * 查询区域代理配置
 * @param params
 * @return {AxiosPromise}
 */
export function appversionGetList(params) {
  return request({
    url: "/appversion/getList",
    method: "get",
    params
  });
}
/**
 * 修改版本状态
 * @param params
 * @returns {AxiosPromise}
 */
export function updateAppversionStatus(params) {
  return request.post("/appversion/updateStatus", qs.stringify(params));
}

/**
 * 上传APP包
 * @type {string}
 */
export function uploadPacket(params) {
  const formData = new FormData();
  formData.append("file", params.file);
  return request.post('/appversion/upload/packet',formData);
}
// ================================== APP版本管理 end=================


// ================================== 外部服务配置 start=================
/**
 * 查询外部服务配置
 * @param params
 * @return {AxiosPromise}
 */
export function getOutsideDetail(params) {
  return request({
    url: "/outsideconfig/getDetail",
    method: "get",
    params
  });
}
/**
 * 编辑壹玖支付配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editYijiu(params) {
  return request.post("/outsideconfig/editYijiu", qs.stringify(params));
}
/**
 * 编辑微信配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editWechat(params) {
  return request.post("/outsideconfig/editWechat", qs.stringify(params));
}
/**
 * 编辑Jeepay支付配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editJeepay(params) {
  return request.post("/outsideconfig/editJeepay", qs.stringify(params));
}
/**
 * 编辑支付宝登录配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editAliLogin(params) {
  return request.post("/outsideconfig/editAli", qs.stringify(params));
}


/**
 * 编辑支付宝支付配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editAliPay(params) {
  return request.post("/outsideconfig/editAliPay", qs.stringify(params));
}

// 支付宝支付改变状态
export function switchAliPayStatus(params) {
  return request.post("/outsideconfig/editAliPayStatus", qs.stringify(params));
}

// ================================== 外部服务配置 end=================


// ================================== 分享海报设置 start=================

/**
 * 查询分享海报列表
 * @param params
 * @return {AxiosPromise}
 */
export function getShareposterList(params) {
  return request({
    url: "/shareposter/getList",
    method: "get",
    params
  });
}
/**
 * 新增-编辑分享海报配置
 * @param params
 * @returns {AxiosPromise}
 */
export function editPoster(params) {
  return request.post("/shareposter/editPoster", qs.stringify(params));
}

/**
 * 修改分享海报状态
 * @param params
 * @returns {AxiosPromise}
 */
export function editPosterStatus(params) {
  return request.post("/shareposter/editPosterStatus", qs.stringify(params));
}
/**
 * 预览
 * @param params
 * @return {AxiosPromise}
 */
export function previewPoster(params) {
  return request({
    url: "/shareposter/preview",
    method: "get",
    params
  });
}
// ================================== 分享海报设置 end=================


// ================================== APP轮播图 start=================

/**
 * 查询APP轮播图列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getCarouselList(params) {
  return request({
    url: "/carouselimg/getList",
    method: "get",
    params,
  });
}
/**
 * 新增-编辑APP轮播图配置
 * @param params
 * @return {AxiosPromise}
 */
export function carouselEdit(params) {
  return request.post("/carouselimg/edit", qs.stringify(params));
}

/**
 * 修改APP轮播图状态
 * @param params
 * @return {AxiosPromise}
 */
export function editCarouselStatus(params) {
  return request.post("/carouselimg/editStatus", qs.stringify(params));
}
// ================================== APP轮播图 end=================

// 新增企业等级配置：/userLevel/edit
export function editEnterpriseConfigLevel(params) {
  return request.post("/userLevel/edit", qs.stringify(params));
}
// 查询企业配置：/userLevel/getList
export function getEnterpriseConfigLevel(params) {
  return request({
    url: "/userLevel/getList",
    method: "get",
    params,
  });
}
